import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';


const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />))
    (({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: '#9c27b0',
      boxShadow: theme.shadows[1],
      fontSize: 12,
      fontWeight: 800,
      fontFamily: 'Baloo'}
}));

export default LightTooltip;